export default __webpack_public_path__ + "media/images/images_v2/onglettitre-small-9ddb8d311da51822ea6fb35c90795ec9.png";